<template>
  <div>
    <section class="bg-white py-8 border-b-2 border-gray-300">
      <div class="w-full md:w-10/12 mx-auto flex flex-wrap px-4 md:px-0">
        <div class="flex w-full md:w-2/3 lg:w-1/2 flex-col justify-center items-start">
          <h2 class="font-bold text-2xl">Hi, {{ $store.state.loggedInUser.name }}</h2>
          <div class="flex items-center mt-5">
            <h3 class="text-xl text-gray-600 mr-5">Current Plan:</h3>
            <div
              class="text-center px-6 py-1 rounded-full font-bold"
              :class="{ 'bg-yellow-400 text-yellow-800': $store.state.loggedInUser.plan == 'Free', 'bg-blue-400 text-blue-800': $store.state.loggedInUser.plan == 'Pro', 'bg-purple-300 text-purple-800': $store.state.loggedInUser.plan == 'Enterprise' }"
            >{{ $store.state.loggedInUser.plan }}</div>
          </div>
          <p class="mt-5 text-gray-600">
            Welcome to your Webpart Store account portal.
            <br />Please find your available downloads below.
          </p>
          <p class="mt-5 text-gray-600">
            For more information on installing the webpart see
            <a href="https://docs.microsoft.com/en-us/sharepoint/use-app-catalog" target="_blank">here</a>
          </p>
        </div>
        <div class="flex w-full md:w-1/3 lg:w-1/2 flex-col py-4 justify-center items-end">
          <!-- <button
            @click="showUpgradePlanModal = !showUpgradePlanModal"
            class="bg-blue-200 hover:bg-blue-300 text-blue-900 font-semibold py-2 pl-3 pr-4 border border-blue-400 rounded hover:shadow inline-flex items-center"
          >
            <svg class="fill-current w-6 h-6 mr-2" viewBox="0 0 24 24">
              <path d="M21,9L17,5V8H10V10H17V13M7,11L3,15L7,19V16H14V14H7V11Z" />
            </svg>
            <span>Change Plan</span>
          </button>-->
        </div>
      </div>
      <div
        v-if="showUpgradePlanModal"
        class="fixed flex justify-center items-center px-5 sm:px-10 md:px-20 lg:px-40 py-5 sm:py-20 lg:py-32 inset-0"
      >
        <div @click="showUpgradePlanModal = false" class="fixed inset-0 bg-black-background-faint"></div>
        <div class="rounded bg-white w-full h-full z-50 overflow-y-scroll">
          <header
            class="bg-gray-100 border-b-2 border-gray-300 p-6 flex justify-between items-center"
          >
            <h2 class="font-bold text-2xl">Change Plan</h2>
            <button
              @click="closeModal"
              class="bg-white hover:bg-gray-100 text-gray-800 p-1 border border-gray-400 rounded hover:shadow"
            >
              <svg class="fill-current h-8" viewBox="0 0 24 24">
                <path
                  d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"
                />
              </svg>
            </button>
          </header>
          <div v-if="!hasError" class="p-6">
            <div class="flex">
              <h3 class="text-xl text-gray-600 mr-5">Current Plan:</h3>
              <div
                class="text-center px-6 py-1 rounded-full font-bold"
                :class="{ 'bg-yellow-400 text-yellow-800': $store.state.loggedInUser.plan == 'Free', 'bg-blue-400 text-blue-800': $store.state.loggedInUser.plan == 'Pro', 'bg-purple-300 text-purple-800': $store.state.loggedInUser.plan == 'Enterprise' }"
              >{{ $store.state.loggedInUser.plan }}</div>
            </div>
            <div class="flex flex-col pt-6">
              <div class="flex flex-wrap -mx-2 -mb-4">
                <div
                  v-if="$store.state.loggedInUser.plan != 'Free'"
                  class="w-full md:w-1/2 px-2 mb-4"
                >
                  <div
                    @click="selectedUpgradePlan = 'Free'"
                    class="flex flex-col p-6 border-2 border-gray-200 rounded hover:bg-gray-200"
                    :class="{ 'bg-gray-200 border-yellow-200 shadow-lg': selectedUpgradePlan == 'Free' }"
                  >
                    <div
                      class="text-center px-6 py-1 mx-auto rounded-full bg-yellow-300 font-bold text-yellow-800"
                    >Free</div>
                    <p
                      class="mt-2 text-gray-700"
                    >Lorem, ipsum dolor sit amet consectetur adipisicing elit. Exercitationem a, quibusdam provident cum sequi, nemo doloremque placeat nobis, quod voluptas illo recusandae. Exercitationem sint sed amet non voluptatem cumque aliquam.</p>
                  </div>
                </div>
                <div
                  v-if="$store.state.loggedInUser.plan != 'Pro'"
                  class="w-full md:w-1/2 px-2 mb-4"
                >
                  <div
                    @click="selectedUpgradePlan = 'Pro'"
                    class="flex flex-col p-6 border-2 border-gray-200 rounded hover:bg-gray-200"
                    :class="{ 'bg-gray-200 border-blue-200 shadow-lg': selectedUpgradePlan == 'Pro' }"
                  >
                    <div
                      class="text-center px-6 py-1 mx-auto rounded-full bg-blue-300 font-bold text-blue-800"
                    >Pro</div>
                    <p
                      class="mt-2 text-gray-700"
                    >Lorem, ipsum dolor sit amet consectetur adipisicing elit. Exercitationem a, quibusdam provident cum sequi, nemo doloremque placeat nobis, quod voluptas illo recusandae. Exercitationem sint sed amet non voluptatem cumque aliquam.</p>
                  </div>
                </div>
                <div
                  v-if="$store.state.loggedInUser.plan != 'Enterprise'"
                  class="w-full md:w-1/2 px-2 mb-4"
                >
                  <div
                    @click="selectedUpgradePlan = 'Enterprise'"
                    class="flex flex-col p-6 border-2 border-gray-200 rounded hover:bg-gray-200"
                    :class="{ 'bg-gray-200 border-purple-200 shadow-lg': selectedUpgradePlan == 'Enterprise' }"
                  >
                    <div
                      class="text-center px-6 py-1 mx-auto rounded-full bg-purple-300 font-bold text-purple-800"
                    >Enterprise</div>
                    <p
                      class="mt-2 text-gray-700"
                    >Lorem, ipsum dolor sit amet consectetur adipisicing elit. Exercitationem a, quibusdam provident cum sequi, nemo doloremque placeat nobis, quod voluptas illo recusandae. Exercitationem sint sed amet non voluptatem cumque aliquam.</p>
                  </div>
                </div>
              </div>

              <div v-if="selectedUpgradePlan != ''">
                <div class="my-4">
                  <svg class="fill-current h-10 mx-auto" viewBox="0 0 24 24">
                    <path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z" />
                  </svg>
                </div>
                <div
                  v-if="$store.state.loggedInUser.stripe_id != null"
                  class="border-l-4 border-green-400 bg-green-200 text-green-800 py-5 rounded pl-4"
                >You have payment details attached to your account.</div>
                <div
                  v-if="$store.state.loggedInUser.stripe_id == null"
                  class="border-l-4 border-red-400 bg-red-200 text-reg-800 py-5 rounded pl-4"
                >
                  <p class="mb-2">You have no payment details attached to your account.</p>
                  <p>In order to add payment details please continue to Stripe.</p>
                </div>
                <div class="my-4">
                  <svg class="fill-current h-10 mx-auto" viewBox="0 0 24 24">
                    <path d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z" />
                  </svg>
                </div>
                <button
                  @click="completeUpgrade"
                  v-if="$store.state.loggedInUser.stripe_id != null"
                  class="w-full bg-blue-200 hover:bg-blue-300 text-blue-900 font-semibold py-4 px-4 border border-blue-400 rounded hover:shadow flex items-center justify-center"
                >
                  <svg class="fill-current h-8 w-8 mr-5" viewBox="0 0 24 24">
                    <path d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
                  </svg>
                  <span>Complete Plan Change</span>
                </button>
                <button
                  @click="continueToStripe"
                  v-if="$store.state.loggedInUser.stripe_id == null"
                  class="w-full bg-blue-200 hover:bg-blue-300 text-blue-900 font-semibold py-4 px-4 border border-blue-400 rounded hover:shadow"
                >Continue to Payment Portal</button>
              </div>
            </div>
          </div>
          <div v-if="hasError" class="p-40">
            <div
              class="w-full h-full bg-red-200 p-16 border-l-4 border-red-600 rounded text-red-800"
            >
              <h2 class="text-2xl font-bold">Error</h2>
              <p
                class="mt-2 text-lg"
              >There has been an error upgrading your plan. Please try again later</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="py-8">
      <div class="w-full md:w-10/12 mx-auto flex flex-col px-4 md:px-0">
        <h2 class="text-2xl font-semibold">Downloads</h2>

        <div class="rounded shadow bg-white mt-5 flex flex-col sm:p-8">
          <div class="hidden sm:flex sm:border-b-2 border-gray-200 sm:-mx-8 px-8"></div>
          <div
            class="sm:hover:bg-gray-100 border-b-2 border-gray-200 sm:-mx-8 sm:px-8 sm:py-4"
            v-for="(download, d) in downloads"
            :key="d"
          >
            <div class="flex flex-col flex-wrap sm:hidden p-10">
              <div class="flex">
                <span class="text-xl font-semibold mr-2">{{ download.title }}</span>
                <span class="text-gray-700">({{ download.version }})</span>
              </div>

              <span class="mt-2 mb-4 text-gray-600">{{ download.description }}</span>
              <div class="flex justify-center w-full mt-2">
                <a
                  :href="`${publicPath}downloads/${download.file_name}`"
                  target="_blank"
                  class="bg-white hover:bg-gray-200 text-gray-800 text-sm py-4 px-8 border border-gray-400 rounded hover:shadow mr-2 text-center"
                >
                  <svg class="fill-current h-8 mb-2 mx-auto" viewBox="0 0 24 24">
                    <path d="M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z" />/>
                  </svg>
                  <span>Download Bundle</span>
                </a>
              </div>
            </div>
            <div class="hidden sm:flex">
              <div class="w-full flex items-center justify-between">
                <div class="flex flex-col">
                  <div class="flex items-center">
                    <span class="text-xl font-semibold mr-2">{{ download.title }}</span>
                    <span class="text-gray-700">({{ download.version }})</span>
                  </div>
                  <span class="text-gray-600">{{ download.description }}</span>
                </div>
                <div>
                  <a
                    :href="`${publicPath}downloads/${download.file_name}`"
                    target="_blank"
                    class="bg-white hover:bg-gray-200 text-gray-800 text-sm py-2 pl-3 pr-4 border border-gray-400 rounded hover:shadow inline-flex items-center my-1"
                  >
                    <svg class="fill-current h-5 w-5 mr-2" viewBox="0 0 24 24">
                      <path d="M5,20H19V18H5M19,9H15V3H9V9H5L12,16L19,9Z" />
                    </svg>
                    <span>Download Bundle</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="py-8">
      <div class="w-full md:w-10/12 mx-auto flex flex-col px-4 md:px-0">
        <h2 class="text-2xl font-semibold">Payments</h2>

        <div class="rounded shadow bg-white mt-5 flex flex-col sm:p-8">
          <div v-if="!invoicesLoading">
            <div
              v-if="$store.state.loggedInUser.stripe_invoices != null"
              class="hidden sm:flex sm:border-b-2 border-gray-200 sm:-mx-8 px-8"
            >
              <div class="w-3/12 font-bold">Invoice No</div>
              <div class="w-3/12 font-bold">Invoice Date</div>
              <div class="w-1/12 font-bold">Total</div>
              <div class="w-2/12 font-bold">Paid</div>
              <div class="w-3/12 font-bold">Invoice</div>
            </div>
            <div
              class="sm:hover:bg-gray-100 border-b-2 border-gray-200 sm:-mx-8 sm:px-8 sm:py-4"
              v-for="(invoice, i) in $store.state.loggedInUser.stripe_invoices"
              :key="i"
            >
              <div class="flex flex-wrap sm:hidden p-10">
                <div class="flex flex-1 flex-col">
                  <span class="text-lg text-gray-700">{{ invoice.number }}</span>
                  <span
                    class="text-lg text-gray-700"
                  >{{ new Date(invoice.created * 1000).toDateString() }}</span>
                </div>
                <div class="flex flex-0 flex-col items-end">
                  <span
                    class="text-lg text-gray-700"
                  >{{ invoice.currency == 'gbp' ? '£' : `${invoice.currency} ` }}{{ invoice.total / 100 }}</span>
                  <div
                    v-if="invoice.paid == true"
                    class="bg-green-300 text-green-900 font-bold py-1 px-5 text-center rounded-full"
                  >Paid</div>
                  <div
                    v-if="invoice.paid == false"
                    class="bg-red-300 text-red-900 font-bold py-1 px-5 text-center rounded-full"
                  >Not Paid</div>
                </div>
                <div class="flex w-full mt-2">
                  <a
                    :href="invoice.invoice_pdf"
                    target="_blank"
                    class="bg-white w-full hover:bg-gray-200 text-gray-800 text-sm py-4 border border-gray-400 rounded hover:shadow mr-2 text-center"
                  >
                    <svg class="fill-current h-8 mb-2 mx-auto" viewBox="0 0 24 24">
                      <path
                        d="M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H19M10.59,10.08C10.57,10.13 10.3,11.84 8.5,14.77C8.5,14.77 5,16.58 5.83,17.94C6.5,19 8.15,17.9 9.56,15.27C9.56,15.27 11.38,14.63 13.79,14.45C13.79,14.45 17.65,16.19 18.17,14.34C18.69,12.5 15.12,12.9 14.5,13.09C14.5,13.09 12.46,11.75 12,9.89C12,9.89 13.13,5.95 11.38,6C9.63,6.05 10.29,9.12 10.59,10.08M11.4,11.13C11.43,11.13 11.87,12.33 13.29,13.58C13.29,13.58 10.96,14.04 9.9,14.5C9.9,14.5 10.9,12.75 11.4,11.13M15.32,13.84C15.9,13.69 17.64,14 17.58,14.32C17.5,14.65 15.32,13.84 15.32,13.84M8.26,15.7C7.73,16.91 6.83,17.68 6.6,17.67C6.37,17.66 7.3,16.07 8.26,15.7M11.4,8.76C11.39,8.71 11.03,6.57 11.4,6.61C11.94,6.67 11.4,8.71 11.4,8.76Z"
                      />
                    </svg>
                    <span>Download PDF</span>
                  </a>
                  <a
                    :href="invoice.hosted_invoice_url"
                    target="_blank"
                    class="bg-white w-full hover:bg-gray-200 text-gray-800 text-sm py-4 border border-gray-400 rounded hover:shadow ml-2 text-center"
                  >
                    <svg class="fill-current h-8 mb-2 mx-auto" viewBox="0 0 24 24">
                      <path
                        d="M16.36,14C16.44,13.34 16.5,12.68 16.5,12C16.5,11.32 16.44,10.66 16.36,10H19.74C19.9,10.64 20,11.31 20,12C20,12.69 19.9,13.36 19.74,14M14.59,19.56C15.19,18.45 15.65,17.25 15.97,16H18.92C17.96,17.65 16.43,18.93 14.59,19.56M14.34,14H9.66C9.56,13.34 9.5,12.68 9.5,12C9.5,11.32 9.56,10.65 9.66,10H14.34C14.43,10.65 14.5,11.32 14.5,12C14.5,12.68 14.43,13.34 14.34,14M12,19.96C11.17,18.76 10.5,17.43 10.09,16H13.91C13.5,17.43 12.83,18.76 12,19.96M8,8H5.08C6.03,6.34 7.57,5.06 9.4,4.44C8.8,5.55 8.35,6.75 8,8M5.08,16H8C8.35,17.25 8.8,18.45 9.4,19.56C7.57,18.93 6.03,17.65 5.08,16M4.26,14C4.1,13.36 4,12.69 4,12C4,11.31 4.1,10.64 4.26,10H7.64C7.56,10.66 7.5,11.32 7.5,12C7.5,12.68 7.56,13.34 7.64,14M12,4.03C12.83,5.23 13.5,6.57 13.91,8H10.09C10.5,6.57 11.17,5.23 12,4.03M18.92,8H15.97C15.65,6.75 15.19,5.55 14.59,4.44C16.43,5.07 17.96,6.34 18.92,8M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
                      />
                    </svg>
                    <span>Online Invoice</span>
                  </a>
                </div>
              </div>
              <div class="hidden sm:flex">
                <div class="w-3/12 flex items-center">
                  <span>{{ invoice.number }}</span>
                </div>
                <div
                  class="w-3/12 flex items-center"
                >{{ new Date(invoice.created * 1000).toDateString() }}</div>
                <div
                  class="w-1/12 flex items-center"
                >{{ invoice.currency == 'gbp' ? '£' : `${invoice.currency} ` }}{{ invoice.total / 100 }}</div>
                <div class="w-2/12 flex items-center">
                  <div
                    v-if="invoice.paid == true"
                    class="bg-green-300 text-green-900 font-bold py-1 px-5 text-center rounded-full"
                  >Paid</div>
                  <div
                    v-if="invoice.paid == false"
                    class="bg-red-300 text-red-900 font-bold py-1 px-5 text-center rounded-full"
                  >Not Paid</div>
                </div>
                <div class="w-3/12 flex flex-wrap justify-between">
                  <a
                    :href="invoice.invoice_pdf"
                    target="_blank"
                    class="bg-white hover:bg-gray-200 text-gray-800 text-sm py-2 pl-3 pr-4 border border-gray-400 rounded hover:shadow inline-flex items-center my-1"
                  >
                    <svg class="fill-current h-5 w-5 mr-2" viewBox="0 0 24 24">
                      <path
                        d="M19,3A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5C3.89,21 3,20.1 3,19V5C3,3.89 3.89,3 5,3H19M10.59,10.08C10.57,10.13 10.3,11.84 8.5,14.77C8.5,14.77 5,16.58 5.83,17.94C6.5,19 8.15,17.9 9.56,15.27C9.56,15.27 11.38,14.63 13.79,14.45C13.79,14.45 17.65,16.19 18.17,14.34C18.69,12.5 15.12,12.9 14.5,13.09C14.5,13.09 12.46,11.75 12,9.89C12,9.89 13.13,5.95 11.38,6C9.63,6.05 10.29,9.12 10.59,10.08M11.4,11.13C11.43,11.13 11.87,12.33 13.29,13.58C13.29,13.58 10.96,14.04 9.9,14.5C9.9,14.5 10.9,12.75 11.4,11.13M15.32,13.84C15.9,13.69 17.64,14 17.58,14.32C17.5,14.65 15.32,13.84 15.32,13.84M8.26,15.7C7.73,16.91 6.83,17.68 6.6,17.67C6.37,17.66 7.3,16.07 8.26,15.7M11.4,8.76C11.39,8.71 11.03,6.57 11.4,6.61C11.94,6.67 11.4,8.71 11.4,8.76Z"
                      />
                    </svg>
                    <span>Download PDF</span>
                  </a>
                  <a
                    :href="invoice.hosted_invoice_url"
                    target="_blank"
                    class="bg-white hover:bg-gray-200 text-gray-800 text-sm py-2 pl-3 pr-4 border border-gray-400 rounded hover:shadow inline-flex items-center my-1"
                  >
                    <svg class="fill-current h-5 w-5 mr-2" viewBox="0 0 24 24">
                      <path
                        d="M16.36,14C16.44,13.34 16.5,12.68 16.5,12C16.5,11.32 16.44,10.66 16.36,10H19.74C19.9,10.64 20,11.31 20,12C20,12.69 19.9,13.36 19.74,14M14.59,19.56C15.19,18.45 15.65,17.25 15.97,16H18.92C17.96,17.65 16.43,18.93 14.59,19.56M14.34,14H9.66C9.56,13.34 9.5,12.68 9.5,12C9.5,11.32 9.56,10.65 9.66,10H14.34C14.43,10.65 14.5,11.32 14.5,12C14.5,12.68 14.43,13.34 14.34,14M12,19.96C11.17,18.76 10.5,17.43 10.09,16H13.91C13.5,17.43 12.83,18.76 12,19.96M8,8H5.08C6.03,6.34 7.57,5.06 9.4,4.44C8.8,5.55 8.35,6.75 8,8M5.08,16H8C8.35,17.25 8.8,18.45 9.4,19.56C7.57,18.93 6.03,17.65 5.08,16M4.26,14C4.1,13.36 4,12.69 4,12C4,11.31 4.1,10.64 4.26,10H7.64C7.56,10.66 7.5,11.32 7.5,12C7.5,12.68 7.56,13.34 7.64,14M12,4.03C12.83,5.23 13.5,6.57 13.91,8H10.09C10.5,6.57 11.17,5.23 12,4.03M18.92,8H15.97C15.65,6.75 15.19,5.55 14.59,4.44C16.43,5.07 17.96,6.34 18.92,8M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
                      />
                    </svg>
                    <span>Online Invoice</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div v-if="invoicesLoading" class="flex items-center justify-center">
            <span class="mdi mdi-loading mdi-spin text-5xl text-gray-500"></span>
          </div>
          <div
            v-if="$store.state.loggedInUser.stripe_invoices == null || isLoading"
            class="bg-blue-200 border-l-4 border-blue-600 rounded pl-4 py-6 text-blue-900 flex items-center"
          >
            <svg class="fill-current h-12 w-12 mr-4" viewBox="0 0 24 24">
              <path
                d="M11,15H13V17H11V15M11,7H13V13H11V7M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20Z"
              />
            </svg>
            <h3 class="text-lg">You have no invoices to show.</h3>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";
import { STRIPE_PUBLIC_KEY, DOWNLOADS } from "@/utils/constants";

const stripe = window.Stripe(STRIPE_PUBLIC_KEY);

export default {
  name: "subscription",
  components: {},
  data() {
    return {
      isLoading: false,
      hasError: false,
      invoicesLoading: true,
      showUpgradePlanModal: false,
      selectedUpgradePlan: "",
      downloads: [],
      publicPath: process.env.BASE_URL
    };
  },
  mounted() {
    this.$nextTick(async () => {
      await this.loadInvoices();
      this.selectedUpgradePlan = "";
      this.downloads = DOWNLOADS;
    });
  },
  methods: {
    loadInvoices: async function() {
      this.invoicesLoading = true;
      await this.$store.dispatch(
        "getStripeInvoices",
        this.$store.state.loggedInUser.stripe_id
      );
      this.invoicesLoading = false;
    },
    continueToStripe: async function() {
      this.isLoading = true;
      try {
        let response = await axios.put("/api/manage-plan/change", {
          plan: this.selectedUpgradePlan
        });
        console.log("response: ", response);
        stripe.redirectToCheckout({
          sessionId: response.data
        });
      } catch (error) {
        console.error(error);
        this.buttonLoading = false;
      }
    },
    completeUpgrade: async function() {
      this.hasError = false;
      this.isLoading = true;
      try {
        await axios.put("/api/manage-plan/change", {
          plan: this.selectedUpgradePlan
        });
        this.$store.dispatch("getUserProfile");
        this.isLoading = false;
        this.showUpgradePlanModal = false;
        await this.loadInvoices();
        // SUCCESS NOTIFICATION
      } catch (error) {
        console.error(error);
        this.isLoading = false;
        this.hasError = true;
      }
    },
    closeModal: function() {
      this.showUpgradePlanModal = false;
      this.selectedUpgradePlan = "";
    }
  }
};
</script>

<style scoped>
</style>